export const NICEPAY_PAYMENT_METHODS = [
  { id: "card", label: "신용/체크카드" },
  { id: "kakaopay", label: "카카오페이" },
  { id: "vbank", label: "무통장입금" },
] as const;

export type NicepayPaymentMethod = (typeof NICEPAY_PAYMENT_METHODS)[number]["id"];

// JCG-2628: Nicepay에 운영 MID의 예금주명 변경 허용 여부를 문의 중이다.
// 답변에 따라 확정된 표시명으로 변경하되 결제창 제한(10 bytes)을 지킨다.
export const NICEPAY_VBANK_HOLDER = "정처기감자";
export const NICEPAY_VBANK_VALID_HOURS = 24;

export type NicepayOrderStatus =
  | "ready"
  | "paid"
  | "expired"
  | "cancelled";

export type NicepayVbankInfo = {
  code: string | null;
  name: string | null;
  number: string | null;
  holder: string | null;
  expiresAt: string | null;
};

export function isNicepayPaymentMethod(
  value: unknown
): value is NicepayPaymentMethod {
  return NICEPAY_PAYMENT_METHODS.some((method) => method.id === value);
}

export function nicepayVbankOptions(
  method: NicepayPaymentMethod
): { vbankHolder?: string; vbankValidHours?: number } {
  return method === "vbank"
    ? {
        vbankHolder: NICEPAY_VBANK_HOLDER,
        vbankValidHours: NICEPAY_VBANK_VALID_HOURS,
      }
    : {};
}

function stringValue(value: unknown): string | null {
  return typeof value === "string" && value.trim().length > 0
    ? value.trim()
    : null;
}

/**
 * Nicepay 승인 응답(flat vbank*)과 웹훅(nested vbank) 형태를 하나로 정규화한다.
 */
export function getNicepayVbankInfo(
  payload: Record<string, unknown>
): NicepayVbankInfo {
  const nested =
    payload.vbank && typeof payload.vbank === "object"
      ? (payload.vbank as Record<string, unknown>)
      : {};

  return {
    code:
      stringValue(payload.vbankCode) ??
      stringValue(nested.vbankCode) ??
      stringValue(nested.code),
    name:
      stringValue(payload.vbankName) ??
      stringValue(nested.vbankName) ??
      stringValue(nested.name),
    number:
      stringValue(payload.vbankNumber) ??
      stringValue(nested.vbankNumber) ??
      stringValue(nested.number),
    holder:
      stringValue(payload.vbankHolder) ??
      stringValue(nested.vbankHolder) ??
      stringValue(nested.holder),
    expiresAt:
      stringValue(payload.vbankExpDate) ??
      stringValue(nested.vbankExpDate) ??
      stringValue(nested.expDate),
  };
}

export function isNicepayVbankReady(
  payload: Record<string, unknown>
): boolean {
  return payload.status === "ready" && payload.payMethod === "vbank";
}
